import moment from "moment";
import { useOrderFlow } from "../OrderFlowProvider/OrderFlowContext";
import { checkIfOrderContainsShortWeek } from "../components/modules/StartDate/useStartDate";
export const NO_ERROR_MESSAGE = "N/A";
const MEAL_DATE_FORMAT = "MM/DD/YYYY";
const GetMealDays = (meals) => {
    let mealDays = [];
    meals.forEach((meal) => {
        if (!mealDays.includes(moment(meal.MealDate).format(MEAL_DATE_FORMAT))) {
            mealDays.push(moment(meal.MealDate).format(MEAL_DATE_FORMAT));
        }
    });
    return mealDays;
};
const GetProductDays = (products) => {
    let productDays = [];
    products.forEach((product) => {
        if (!productDays.includes(product.DayOfWeek)) {
            productDays.push(product.DayOfWeek);
        }
    });
    return productDays.sort((a, b) => a - b);
};
const GetMealsPerOrder = (meals) => {
    let mealCount = 0;
    GetMealDays(meals).forEach((mealDay) => {
        meals.forEach((meal) => {
            if (moment(meal.MealDate).format(MEAL_DATE_FORMAT) == mealDay) {
                mealCount += meal.Quantity;
            }
        });
    });
    return mealCount;
};
const GetMealsPerDay = (meals, mealDay) => {
    let mealCount = 0;
    meals.forEach((meal) => {
        if (moment(meal.MealDate).format(MEAL_DATE_FORMAT) == mealDay) {
            mealCount += meal.Quantity;
        }
    });
    return mealCount;
};
/**
 * Gets the total cost of all Meals
 * @param meal
 * @returns totalCost
 */
const getTotalMealCost = (meal) => {
    var _a, _b, _c, _d;
    if (!meal)
        return 0;
    const totalAssignmentQuantity = (_b = (_a = meal.RecipeAssignments) === null || _a === void 0 ? void 0 : _a.reduce((total, assignment) => total + assignment.Quantity, 0)) !== null && _b !== void 0 ? _b : 0;
    const totalAssignmentCost = (_d = (_c = meal.RecipeAssignments) === null || _c === void 0 ? void 0 : _c.reduce((total, assignment) => {
        var _a;
        const totalCustomizationCost = getSelectedIngredientOptionTotal(assignment.SelectedIngredientOptions);
        const assignmentCostWithCustomization = (totalCustomizationCost + ((_a = assignment.RecipeAssignmentPrice) !== null && _a !== void 0 ? _a : 0)) * assignment.Quantity;
        return total + assignmentCostWithCustomization;
    }, 0)) !== null && _d !== void 0 ? _d : 0;
    const remainingMealQuantity = meal.Quantity - totalAssignmentQuantity;
    // Total of all meals with recipe assignments plus remaining meals without recipe assignments
    const totalCost = totalAssignmentCost + remainingMealQuantity * meal.Price;
    return parseFloat(totalCost.toFixed(2));
};
/**
 * Calculates the total of all selected ingredient options
 *
 * @param selectedOptions
 * @returns
 */
export const getSelectedIngredientOptionTotal = (selectedOptions) => {
    let totalPrice = 0;
    selectedOptions.forEach((option) => {
        option.selectedOptions.forEach((selectedOption) => {
            if (selectedOption.replacementPrice !== undefined) {
                totalPrice += selectedOption.replacementPrice;
            }
        });
    });
    return totalPrice;
};
const getTotalAmountForDay = (meals, products, mealDay) => {
    let mealsForDayCost = 0;
    let productsForDayCost = 0;
    meals.forEach((meal) => {
        if (moment(meal.MealDate).format(MEAL_DATE_FORMAT) === mealDay) {
            mealsForDayCost += getTotalMealCost(meal);
        }
    });
    productsForDayCost = getTotalProductAmountPerDay(products, moment(mealDay).weekday());
    return mealsForDayCost + productsForDayCost;
};
const getTotalProductAmountPerDay = (products, day) => {
    let productsForDayCost = 0;
    products.forEach((product) => {
        if (day === product.DayOfWeek) {
            const cost = product.hasSale ? product.salePrice : product.productPrice;
            productsForDayCost += cost * product.quantity;
        }
    });
    return productsForDayCost;
};
const getTotalAmountForOrder = (meals, products) => {
    let mealForOrderCost = 0;
    meals.forEach((meal) => {
        mealForOrderCost += getTotalMealCost(meal);
    });
    let productsForOrderCost = 0;
    products
        .filter((p) => p.quantity > 0)
        .forEach((p) => {
        let price = p.hasSale ? p.salePrice : p.productPrice;
        productsForOrderCost += price * p.quantity;
    });
    return mealForOrderCost + productsForOrderCost;
};
const GetSubscriptionMealsForOrder = (isSubscription, cartDayQuantity, cartDaysOfWeek, cartStartDate, cartTemplate, onlyShowDeliveryDays, modelDeliveryDays) => () => {
    let subscriptionMeals = [];
    if (isSubscription) {
        let dayQuantity = cartDayQuantity;
        if (!dayQuantity) {
            dayQuantity = cartDaysOfWeek.length;
        }
        const orderIsShortWeek = checkIfOrderContainsShortWeek(cartStartDate, cartDaysOfWeek, cartDayQuantity);
        let daysForSubscription = [];
        if (orderIsShortWeek) {
            daysForSubscription = cartDaysOfWeek.slice(0, dayQuantity);
        }
        else {
            daysForSubscription = cartDaysOfWeek.filter((day) => day >= moment(cartStartDate).day()).slice(0, dayQuantity);
        }
        subscriptionMeals =
            cartTemplate &&
                cartTemplate
                    .filter((mealDayQuantity) => modelDeliveryDays.some((day) => moment(day.MealDate).day() === mealDayQuantity.DayOfWeek) &&
                    daysForSubscription.some((day) => day === mealDayQuantity.DayOfWeek))
                    .map((mealDayQuantity) => {
                    var _a;
                    let dayOfWeek = mealDayQuantity.DayOfWeek;
                    if (onlyShowDeliveryDays) {
                        dayOfWeek = moment((_a = modelDeliveryDays.find((dd) => moment(dd.MealDateString).day() === mealDayQuantity.DayOfWeek)) === null || _a === void 0 ? void 0 : _a.ShipDateString).day();
                    }
                    return {
                        MealId: mealDayQuantity.ProgramMealId,
                        Qty: mealDayQuantity.Quantity,
                        DayOfWeek: dayOfWeek,
                        MealName: mealDayQuantity.ProgramMealName,
                    };
                });
        if (onlyShowDeliveryDays) {
            let mealIds = [...new Set(subscriptionMeals.map((sm) => sm.MealId))];
            let daysOfWeek = [...new Set(subscriptionMeals.map((sm) => sm.DayOfWeek))];
            mealIds.forEach((mealId) => {
                daysOfWeek.forEach((dayOfWeek) => {
                    let duplicates = subscriptionMeals.filter((sm) => sm.MealId === mealId && sm.DayOfWeek === dayOfWeek);
                    if (duplicates.length > 1) {
                        let newQuantity = duplicates.reduce((acc, sm) => acc + sm.Qty, 0);
                        subscriptionMeals = subscriptionMeals.filter((sm) => sm.MealId !== mealId || sm.DayOfWeek !== dayOfWeek);
                        subscriptionMeals.push({
                            MealId: mealId,
                            Qty: newQuantity,
                            DayOfWeek: dayOfWeek,
                            MealName: duplicates[0].MealName,
                        });
                    }
                });
            });
        }
    }
    return subscriptionMeals;
};
const GenerateResponse = (meetsRequirement, requirement) => ({
    meetsRequirements: meetsRequirement,
    errorMessage: (requirement === null || requirement === void 0 ? void 0 : requirement.ErrorMsg) || (requirement === null || requirement === void 0 ? void 0 : requirement.TextValue) || NO_ERROR_MESSAGE,
});
/**
 * Hook with various helper functions that do calculations for Order Flow
 * @returns
 */
export const useCalculations = () => {
    const { store } = useOrderFlow();
    return {
        GetMealDays,
        GetProductDays,
        GetMealsPerOrder,
        GetMealsPerDay,
        getTotalAmountForDay,
        getTotalProductAmountPerDay,
        getTotalAmountForOrder,
        GetSubscriptionMealsForOrder: GetSubscriptionMealsForOrder(store.cart.isSubscription, store.cart.dayQuantity, store.cart.daysOfWeek, store.cart.startDate, store.cart.template, store.model.GeneralSettings.OnlyShowDeliveryDays, store.model.DeliveryDays),
        GenerateResponse,
    };
};
